import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[appDynamicPopover]'
})
export class DynamicPopoverDirective implements OnInit {
  @Input() appDynamicPopover: NgbPopover;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.setPopoverPlacement();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setPopoverPlacement();
  }

  private setPopoverPlacement() {
    const targetRect = this.el.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    if (viewportHeight - targetRect.bottom > 150) {
      this.appDynamicPopover.placement = 'bottom';
    } else {
      this.appDynamicPopover.placement = 'top';
    }
  }
}
